import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { getBasePath } from './utils/basePath';

// <base> fixes relative ./assets on deep URLs but breaks React Router; remove before mount.
document.getElementById('app-deploy-base')?.remove();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

const link: HTMLLinkElement | null = document.querySelector("link[rel='icon']");
if (link) {
  link.href = `${getBasePath()}favicon.png`;
}

reportWebVitals();
